(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ModelosEducativosService', ModelosEducativosService);

    ModelosEducativosService.$inject = ['$resource'];

    function ModelosEducativosService ($resource) {
        var resourceUrl =  'apo/modelosEducativos';

        return $resource(resourceUrl, {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();
